/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  FaqResponseDto
} from '../../schemas';

import { customFetchProtected } from '../../../custom-fetcher';

export type getFaqsResponse200 = {
  data: FaqResponseDto
  status: 200
}

export type getFaqsResponseSuccess = (getFaqsResponse200) & {
  headers: Headers;
};
;

export type getFaqsResponse = (getFaqsResponseSuccess)

export const getGetFaqsUrl = () => {




  return `/api/v1/faqs`
}

export const getFaqs = async ( options?: RequestInit): Promise<getFaqsResponse> => {

  return customFetchProtected<getFaqsResponse>(getGetFaqsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


